import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

(window as any).__BRAIN_EVOLVED_ENVIRONMENT__ = Object.freeze({
  name: environment.name,
  production: environment.production,
  firebaseProjectId: environment.firebase.projectId
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
